/**
 * Funções utilitárias para manipulação de números
 */

/**
 * Gera um número randomico com valor enter min e max
 * @param {Number} min - valor mínimo
 * @param {Number} max - valor máximo
 */
export const getRandomInt = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min)) + min
}

/**
 * Gera ids de forma incremental
 * @param {String} prefix - prefixo usado no id
 */
export const idGenerator = (prefix = '') => {
  let count = 0

  return () => prefix + (count++).toString(10)
}

/**
 * Formata um número em moeda
 * @param {Number} number - valor
 * @param {String} lang - moeda
 * @param {String} currency - moeda
 */
export const converToCurrency = (
  number = 0,
  lang = 'pt-BR',
  currency = 'BRL'
) => {
  const formatter = new Intl.NumberFormat(lang, {
    style: 'currency',
    currency: currency
  })

  return formatter.format(number)
}

/**
 * Gera um identificador unico
 * @returns UUID gerado
 */
export const generateUUID = () => window.crypto.randomUUID()

/**
 * Limita um número dentro de um intervalo definido
 * @param { Number } value: número a ser limitado
 * @param { Number } min: valor mínimo permitido
 * @param { Number } max: valor máximo permitido
 * @returns { Number } valor ajustado dentro do intervalo
 */
export const clampNumber = (value, min = 0, max = 100) => {
  const number = Number(value)
  if (isNaN(number)) return min

  if (max === null) return Math.max(number, min)

  return Math.min(Math.max(number, min), max)
}
